import IconInstagram from "src/icons/IconInstagram";
import ShareItem from "../../components/ShareItem";
import { ShareInstagramDMDataType } from "./shareInstagramDMHelpers";
import useShareInstagramDM from "./useShareInstagramDM";

const ShareInstagramDM = ({ data }: { data: ShareInstagramDMDataType }) => {
	const { handlePress, loading } = useShareInstagramDM(data);

	return <ShareItem Icon={IconInstagram} name="DMs" loading={loading} onPress={handlePress} />;
};
export default ShareInstagramDM;
